<template>
  <aside
    class="v-side-slider"
    :class="{ 'v-side-slider--open': open, 'v-side-slider--dark': dark }"
  >
    <div class="v-side-slider__bg-dark" @click="close" />

    <div class="v-side-slider__wrapper">
      <header class="v-side-slider__header">
        <p class="v-side-slider__title">{{ title }}</p>

        <Feather type="x" class="v-side-slider__icon" @click="close" />
      </header>

      <div class="v-side-slider__body">
        <slot name="body" />
      </div>

      <template v-if="this.$slots.actions">
        <footer class="v-side-slider__footer">
          <slot name="actions" />
        </footer>
      </template>
    </div>
  </aside>
</template>

<script>
import Feather from "vue-feather";

import "./styles.scss";

export default {
  name: "VSideSlider",
  components: {
    Feather
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Title"
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
